import DisplayRAPMetrics from './DisplayRAPSubMetrics';
import DisplayCCXMetrics from './DisplayCCXSubMetrics';
import DisplayCCXNegativeMetrics from './DisplayCCXNegativeSubMetrics';
import DisplayCCXNegativeOneboxMetrics from './DisplayCCXNegativeOneboxSubMetrics';
import DisplayTRSubMetrics from './DisplayTRSubMetrics';
import DisplayDARTSubMetrics from './DisplayDARTSubMetrics';
import DisplayACHTSubMetrics from './DisplayACHTSubMetrics';
import DisplayDCRSubMetrics from './DisplayDCRSubMetrics';
import DisplayDSRSubMetrics from './DisplayDSRSubMetrics';
import DisplaySDRSubMetrics from './DisplaySDRSubMetrics';
import DisplayConsultRateSubMetrics from './DisplayConsultRateSubMetrics';
import DisplayPASubMetrics from './DisplayPolicyAdherenceSubMetrics';
import DisplayConcessionRateSubMetrics from './DisplayConcessionRateSubMetrics';
import DisplayPRRNCSubMetrics from './DisplayPRRNCSubMetrics';
import DisplayUnderstandabilitySubMetrics from './DisplayUnderstandabilitySubMetrics';
import DisplayPRRCISubMetrics from './DisplayPRRCISubMetrics';
import DisplayPRRSubMetrics from './DisplayPRRSubMetrics';
import DisplayHMDOfferRateSubMetrics from './DisplayHMDOfferRateSubMetrics';
import DisplayHmdResponseRateSubMetrics from './DisplayHmdResponseRateSubMetrics';
import { LighthouseMetrics, DisplaySubMetricsProps } from '../types';
import React from 'react';
import { TimeOption } from '@amzn/aet-galactus-kit';

interface DisplayGeneralSubMetricsProps {
  type: string;
  metrics: LighthouseMetrics;
  vertical: string;
  cscEntityPrefix: string;
  skill: string;
  channel: string;
  segment: string;
  marketplace: string;
  timeOption: TimeOption;
  timestamp: string;
}

interface SwitchCaseMap {
  RAP: React.FC<DisplaySubMetricsProps>;
  CCX: React.FC<DisplaySubMetricsProps>;
  TR: React.FC<DisplaySubMetricsProps>;
  DART: React.FC<DisplaySubMetricsProps>;
  ACHT: React.FC<DisplaySubMetricsProps>;
  DCR: React.FC<DisplaySubMetricsProps>;
  DSR: React.FC<DisplaySubMetricsProps>;
  SDR: React.FC<DisplaySubMetricsProps>;
  CONSULT_RATE: React.FC<DisplaySubMetricsProps>;
  POLICY_ADHERENCE: React.FC<DisplaySubMetricsProps>;
  UNDERSTANDABILITY: React.FC<DisplaySubMetricsProps>;
  UNDERSTANDABILITY_NO_CONCESSION: React.FC<DisplaySubMetricsProps>;
  UNDERSTANDABILITY_CONCESSION_ISSUED: React.FC<DisplaySubMetricsProps>;
  CONCESSION_RATE: React.FC<DisplaySubMetricsProps>;
  PRRNC: React.FC<DisplaySubMetricsProps>;
  PRRCI: React.FC<DisplaySubMetricsProps>;
  PRR: React.FC<DisplaySubMetricsProps>;
  HMD_OFFER_RATE: React.FC<DisplaySubMetricsProps>;
  HMD_RESPONSE_RATE: React.FC<DisplaySubMetricsProps>;
  default: () => JSX.Element;
}

const SwitchMap = {
  RAP: DisplayRAPMetrics,
  CCX: DisplayCCXMetrics,
  CCX_NEG: DisplayCCXNegativeMetrics,
  CCX_NEG_ONEBOX: DisplayCCXNegativeOneboxMetrics,
  TR: DisplayTRSubMetrics,
  DART: DisplayDARTSubMetrics,
  ACHT: DisplayACHTSubMetrics,
  DCR: DisplayDCRSubMetrics,
  DSR: DisplayDSRSubMetrics,
  SDR: DisplaySDRSubMetrics,
  CONSULT_RATE: DisplayConsultRateSubMetrics,
  POLICY_ADHERENCE: DisplayPASubMetrics,
  UNDERSTANDABILITY: DisplayUnderstandabilitySubMetrics,
  UNDERSTANDABILITY_NO_CONCESSION: () => <></>,
  UNDERSTANDABILITY_CONCESSION_ISSUED: () => <></>,
  CONCESSION_RATE: DisplayConcessionRateSubMetrics,
  PRRNC: DisplayPRRNCSubMetrics,
  PRRCI: DisplayPRRCISubMetrics,
  PRR: DisplayPRRSubMetrics,
  HMD_OFFER_RATE: DisplayHMDOfferRateSubMetrics,
  HMD_RESPONSE_RATE: DisplayHmdResponseRateSubMetrics,
  FCR: () => <></>,
  default: () => <></>,
};

const DisplaySubMetrics: React.FC<DisplayGeneralSubMetricsProps> = ({
  type,
  metrics,
  vertical,
  cscEntityPrefix,
  skill,
  channel,
  segment,
  marketplace,
  timeOption,
  timestamp,
}: DisplayGeneralSubMetricsProps): React.ReactElement => {
  const SwitchCase = SwitchMap[type as keyof SwitchCaseMap];

  return SwitchCase ? (
    <SwitchCase
      metrics={metrics}
      vertical={vertical}
      cscEntityPrefix={cscEntityPrefix}
      skill={skill}
      channel={channel}
      segment={segment}
      marketplace={marketplace}
      timeOption={timeOption}
      timestamp={timestamp}
    />
  ) : (
    <></>
  );
};

export default DisplaySubMetrics;
